import {createTheme} from '@mui/material/styles';

const BNPP_TYPE_LIGHT_SANS = 'bnpp-type-light, sans-serif';
const BNPP_TYPE_REGULAR_SANS = 'bnpp-type-regular, sans-serif';
const BGL_GREEN = '#00915A !important';
export const globalTheme = createTheme({

    palette: {
        primary: {
            main: '#00915a'
        },
        secondary: {
            main: '#ccc'
        },
        text: {
            primary: '#333'
        }
    },

    typography: {
        useNextVariants: true
    },

    components: {
        MuiTypography: {
            styleOverrides: {
                root: {
                    letterSpacing: 'inherit !important'
                },
                h1: {
                    fontSize: '4.375rem',
                    fontFamily: 'bnpp-sans-cond-light',
                    textTransform: 'uppercase'
                },

                h2: {
                    fontSize: '4.375rem',
                    fontFamily: 'bnpp-sans-cond-light'
                },

                h3: {
                    fontSize: '2.375rem',
                    fontFamily: 'bnpp-type-light'
                },

                h4: {
                    fontSize: '42px',
                    fontFamily: BNPP_TYPE_LIGHT_SANS
                },
                h5: {
                    fontSize: '35px',
                    fontFamily: BNPP_TYPE_LIGHT_SANS
                },
                h6: {
                    fontSize: '22px',
                    fontFamily: 'bnpp-type-book, sans-serif'
                },
                subtitle1: {
                    fontSize: '18px',
                    fontFamily: BNPP_TYPE_LIGHT_SANS
                },
                body1: {
                    fontSize: '16px',
                    fontFamily: BNPP_TYPE_LIGHT_SANS
                },
                body2: {
                    fontSize: '16px',
                    fontFamily: BNPP_TYPE_REGULAR_SANS
                },

                subtitle2: {
                    fontSize: '40px',
                    fontFamily: 'bnpp-sans-cond-light, sans-serif',
                    color: '#fff'
                },

                overline: {
                    fontSize: '16px',
                    fontFamily: BNPP_TYPE_REGULAR_SANS,
                    color: '#00915a',
                    letterSpacing: 'inherit'
                },

                caption: {
                    fontSize: '14px',
                    fontFamily: BNPP_TYPE_LIGHT_SANS,
                    color: 'rgba(0,0,0,.5)'
                }
            }
        },
        MuiModal: {
            styleOverrides: {
                root: {
                    paddingRight: '0px !important'
                }
            }
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    display: 'table-column',
                    direction: 'rtl',
                    minHeight: '48px !important',
                    margin: '10px 0px 0 0',
                    padding: '0px!important'
                }
            }
        },
        MuiButton: {
            styleOverrides : {
                root: {
                    padding: '12px 24px',
                    fontSize: '16px',
                    borderRadius: 0,
                    textTransform: 'none',
                    fontFamily: BNPP_TYPE_REGULAR_SANS
                },

                containedPrimary: {
                    border: '1px solid #00915a',
                    boxShadow: 'none',
                    '&:hover': {
                        color: '#fff'
                    },

                    '&:disabled': {
                        border: 'rgba(255, 255, 255, 0.12)'
                    }
                },
                containedSecondary: {
                    background: '#fff !important',
                    border: '1px solid #e0e0e0',
                    color: '#a0a0a0',
                    boxShadow: 'none',
                    '&:hover': {
                        color: '#a0a0a0'
                    }
                },
                outlinedPrimary: {
                    padding: '12px 24px',
                    backgroundColor: '#fff'
                }
            }
        },

        MuiInputBase: {
            styleOverrides: {
                root: {
                    color: '#fff'
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    minHeight: '72px'
                },
                select: {
                    '&:focus': {
                        backgroundColor: 'transparent'
                    }
                },
                selectMenu: {
                    minHeight: 'auto',
                    height: 'none'
                }
            }
        },

        MuiFormControl: {
            styleOverrides: {
                root: {
                    display: 'flex',
                    backgroundColor: '#fff'
                }
            }
        },

        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    backgroundColor: '#f7f7f7',
                    marginTop: 0,
                    paddingTop: '8px'
                }
            }
        },

        MuiInput: {
            styleOverrides : {
                root: {
                    minHeight: '72px',
                    fontFamily: BNPP_TYPE_REGULAR_SANS
                },
                formControl: {
                    marginTop: '0 !important'
                },
                underline: {
                    '&:before, &:hover:before, &:visited:before, &:after': {
                        borderBottomColor: '#073427 !important'
                    }
                },
                input: {
                    padding: '40px 25px 20px 25px',
                    fontSize: '22px'
                }
            }
        },

        MuiInputLabel: {
            styleOverrides: {
                formControl: {
                    top: '10px',
                    left: '25px',
                    fontSize: '20px'
                },
                shrink: {
                    color: '#75bd0e !important'
                }
            }
        },

        MuiDialogContentText: {
            styleOverrides: {
                root: {
                    padding: '25px 0 5px 0'
                }
            }
        },

        MuiTableCell: {
            styleOverrides: {
                root: {
                    padding: 0
                }
            }
        },

        MuiTableRow: {
            styleOverrides : {
                root: {
                    height: '30px'
                }
            }
        },

        MuiCheckbox: {
            styleOverrides: {
                root: {
                    '&$checked': {
                        color: BGL_GREEN
                    }
                }
            }
        },

        MuiListItem: {
            styleOverrides: {
                root: {
                    '&$selected': {
                        color: BGL_GREEN,
                        backgroundColor: 'rgba(0, 0, 0, 0.05) !important'
                    }
                }
            }
        },

        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    borderRadius: 'none',
                    fontSize: '13px',
                    color: '#fff',
                    backgroundColor: '#00915A'
                }
            }
        },

        MuiInputAdornment: {
            styleOverrides: {
                positionEnd: {
                    paddingRight: '10px'
                }
            }
        },

        MuiStepper: {
            styleOverrides: {
                root: {
                    padding: 0
                }
            }
        },

        MuiStepContent: {
            styleOverrides: {
                root: {
                    borderLeft: 'none',
                    marginTop: 0,
                    paddingLeft: 0
                }
            }
        },

        MuiStepLabel: {
            styleOverrides: {
                root: {
                    backgroundColor: '#fff',
                    borderTop: '1px solid #e0e0e0'
                }
            },
            active: {
                backgroundColor: '#f7f7f7',
                border: 'none'
            },

            completed: {
                color: '#333'
            }
        },

        MuiLink: {
            styleOverrides: {
                underlineHover: {
                    '&:hover': {
                        color: BGL_GREEN,
                        borderBottom: '1px dotted',
                        textDecoration: 'none'
                    }
                }
            }
        },

        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: '#00915A'
                }
            }
        },

        MuiSvgIcon: {
            styleOverrides: {
                colorSecondary: {
                    color: '#fff'
                },
                fontSizeLarge: {
                    fontSize: '6rem'
                }
            }
        }

    }
});
